<template>
	<div id="register" class=" body">
		<p class="logo">logo</p>
		<div class="body_count" >
			<div class="login_count">
				<div class="login_count_a">
					<div id="all">
						<ul id="option">
							<li class="login_left">账号注册</li>
						</ul>
						<ul id="card">
							<li class="active">
								<!--输入框-->
								<div class="login_bot_count">
									<input v-model="user.phone" placeholder="请输入手机号" />
									<div class="calls" @click="PostDTM">
										获取验证码
									</div>
								</div>
								<div class="login_bot_count">
									<input v-model="user.yzm" placeholder="请输入验证码" />
								</div>
								<div class="login_bot_count">
									<input style="width: 100%;" v-model="user.phone" disabled placeholder="请输入账户名" />
								</div>
								<div class="login_bot_count">
									<input type="password" v-model="user.password" @blur="yzmm" placeholder="请输入密码" />
								</div>
								<div class="login_bot_count">
									<input type="password" v-model="user.password2" @blur="yzmm2"
										placeholder="请再次输入密码" />
								</div>
								<div class="login_bot">
									<a @click="jhmm()">忘记密码?</a>
									<p @click="jumpTo()">已账号？去登录</p>
								</div>
								<!--注册按钮-->
								<button class="login_button" @click="regiter">注册</button>
								<p style="font-size: 12px;margin-top: 5px;">注册即同意 <a style="color: red;"
										@click="getAgreement">《海工人使用协议》</a> <a style="color: red;"
										@click="getAgreement">《隐私权条款》</a> </p>
							</li>
						</ul>
					</div>
				</div>
			</div>

		</div>
		<!-- 遮罩层 -->
		<div class="popContainer" v-if="isShohgrxy">
			<!-- 海工人使用协议 -->
			<div class="sq_ewm">
				<div class="sq_ewm_title">《{{userAgreement.title}}》</div>
				<div class="gb_sqewm" @click="getAgreement">
					<!-- <img src="../../images/top/GBXh.png"> -->
					<div>×</div>
				</div>
				<!-- 服务协议 -->
				<div class="xy_warp" v-html="userAgreement.content">

				</div>
				<!-- 页脚 -->
				<div class="xy_floot" @click="getAgreement">
					<div>关闭</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShohgrxy: false,
				userAgreement: {
					title: '协议名称',
					content: '协议内容',
				},
				user: {
					phone: '',
					yzm: '',
					userName: '',
					password: '',
					password2: ''
				},
			}
		},
		methods: {
			jumpTo() {
				//指定跳转的地址
				this.$router.replace('/login')
			},
			jhmm(){
				this.$router.replace('/changePassword')
			},
			// 请求使用协议
			getAgreement() {
				this.isShohgrxy = !this.isShohgrxy
			},
			async PostDTM() {
				let key = this.checkPhone()
				if (key) {
					let res = await http.get("api/picture/aliyun", {
						mobile: this.user.phone
					});
					this.$message.success(res.data.msg);
				}
			},
			// 验证手机号
			checkPhone() {
				var phone = this.user.phone
				if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))) {
					this.$message.warning("手机号码有误，请重新填写！");
					return false;
				} else {
					return true
				}
			},
			// 验证密码
			isPasswd(s) {
				var patrn = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;;
				if (!patrn.exec(s)) {
					this.user.password = ''
					this.$message.warning("密码由6-20个字母、数字、特殊符号组成！");
				} else {
					this.$message.success("密码可用!");
				}
			},
			yzmm() {
				this.isPasswd(this.user.password)
			},
			yzmm2() {
				if (this.user.password != this.user.password2) {
					this.$message.error("两次输入不一致，请重新输入！");
				} else {
					this.$message.success("密码可用!");
				}
			},
			async regiter(){
				let res = await http.post('api/login/reg',{
					mobile:this.user.phone,
					username:this.user.phone,
					mobphone:this.user.phone,
					password:this.user.password,
					code:this.user.yzm
				})
				if(res.data.msg=='注册成功'){
					this.$message.success(res.data.msg);
					this.$router.replace('/login')
				} else {
					this.$message.error(res.data.msg);
				}
			}
		}
	}
</script>

<style>
	#register .login_count {
		width: 340px;
		height: 500px;
		padding: 10px;
		background-color: white;
		border-radius: 10px;
		box-shadow: 0px 0px 15px #2aa2a3;
		margin-top: 20px;
	}

	* {
		margin: 0px;
		padding: 0px;
		text-decoration: none;
		list-style: none;
		outline: none;
		box-sizing: border-box;
	}

	.body {
		background-image: url(../../imges/123cf0ee9.jpg);
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		background-size: 100% 100%;
		position: absolute;
	}

	.logo {
		height: 45px;
		margin: 20px 40px;
		font-size: 30px;
		color: white;
	}

	.img_l {
		position: fixed;
		width: 40%;
		top: 25%;
		left: 15%;
	}

	.body_count {
		width: 340px;
		position: fixed;
		top: 20%;
		left: 41%;
	}

	.body_count_top {
		width: 100%;
		text-align: center;
		color: white;
		font-size: 22px;
		font-weight: bold;
		letter-spacing: 8px;
	}

	.login_count_a {
		width: 100%;
	}

	.login_count_a_l {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
	}

	.icon_e {
		height: 18px;
	}

	.login_a_l_t {
		color: white;
		font-size: 12px;
		padding: 3px;
		background: linear-gradient(to right, #26CBD6, #3EE1E2);
	}

	.triangle {
		float: left;
		width: 0;
		height: 0;
		border-width: 11px;
		border-style: solid;
		border-color: transparent #3EE1E2 transparent transparent;
		transform: rotate(180deg);
	}

	#all {
		width: 80%;
		margin: 50px auto 0px;
	}

	#option {
		width: 100%;
		height: 40px;
		line-height: 40px;
		border-radius: 20px;
		border: 1px solid #ceffff;
		margin-bottom: 40px;
	}

	#option li {
		float: left;
		text-align: center;
		width: 100%;
		/*background: white;*/
		height: 38px;
		cursor: pointer;
		color: #4f4f4f;
		font-size: 16px;
		border-radius: 20px;
		font-weight: bold;
	}

	#option li.active {
		background: linear-gradient(to left, #40E4E5, #28CCD6);
		color: white;
		border-radius: 20px;
	}

	#card li {
		height: 100%;
		display: none;
	}

	#card li.active {
		display: block;
	}

	.login_bot_count {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_bot_count>img {
		height: 20px;
		padding-left: 5px;
	}

	.login_bot_count>input {
		height: 35px;
		border: 0px;
		width: 80%;
	}

	.login_bot_count>input::-webkit-input-placeholder {
		color: #dedede;
	}

	.login_bot {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
	}

	.login_bot>a,
	.login_bot>p {
		font-size: 12px;
		color: #898989;
	}

	.login_bot>p {
		width: 33%;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
	}


	/*记住密码勾选框*/

	.login_bot>p>input[type="checkbox"] {
		width: 10px;
		height: 10px;
		display: inline-block;
		text-align: center;
		vertical-align: middle;
		line-height: 10px;
		position: relative;
	}

	.login_bot>p>input[type="checkbox"]::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		background: #fff;
		width: 100%;
		height: 100%;
		border: 1px solid #dedede;
	}

	.login_bot>p>input[type="checkbox"]:checked::before {
		content: "\2713";
		background-color: white;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		border: 1px solid #dedede;
		color: #898989;
		font-size: 12px;
		font-weight: bold;
	}


	/*按钮样式*/

	.login_button {
		margin-top: 20px;
		width: 100%;
		border: 0px;
		height: 35px;
		font-size: 16px;
		color: white;
		background: linear-gradient(to left, #40E4E5, #28CCD6);
	}

	.login_account_count {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_account_count>img {
		height: 20px;
		padding-left: 5px;
	}

	.mobile_input {
		height: 35px;
		border: 0px;
		width: 75%;
	}

	.account_select {
		color: #4F4F4F;
		font-size: 14px;
		border: 0px;
		margin: 0px 5px;
		appearance: none;
		-moz-appearance: none;
		-webkit-appearance: none;
		width: 45px;
		z-index: 999;
		background: none;
	}

	.account_select_icon {
		position: relative;
		left: -8%;
		height: 10px !important;
	}

	.login_account_counts {
		width: 100%;
		border: 1px solid #34D8DE;
		display: inline-flex;
		align-items: center;
		justify-content: space-between;
		height: 40px;
		padding: 3px;
		margin-top: 10px;
	}

	.login_account_counts>img {
		height: 20px;
		padding-left: 5px;
	}

	.login_account_counts>input:nth-of-type(1) {
		height: 35px;
		border: 0px;
		width: 50%;
	}

	.account_code {
		color: white;
		background-color: #26CBD6;
		padding: 5px;
		font-size: 12px;
		cursor: pointer;
		border: 0px;
	}

	.login_account_count>input::-webkit-input-placeholder {
		color: #dedede;
	}

	.login_account_counts>input::-webkit-input-placeholder {
		color: #dedede;
	}


	/*按钮样式*/

	.login_account_button {
		margin-top: 40px;
		width: 100%;
		border: 0px;
		height: 35px;
		font-size: 16px;
		color: white;
		background: linear-gradient(to left, #40E4E5, #28CCD6);
	}

	.login_count_b {
		width: 100%;
		display: none;
	}

	.login_count_b_l {
		width: 100%;
		display: inline-flex;
		align-items: center;
		justify-content: flex-end;
	}

	.icon_e,
	.icon_z {
		height: 18px;
	}

	.login_b_l_t {
		color: white;
		font-size: 12px;
		padding: 3px;
		background: linear-gradient(to right, #26CBD6, #3EE1E2);
	}

	.login_b_title>img {
		height: 22px;
		margin-right: 5px;
	}

	.login_b_title {
		width: 100%;
		margin-top: 30px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: black;
		font-size: 16px;
		font-weight: 1000;
	}

	.libqr {
		width: 60%;
		margin: 10px 20%;
	}

	.libqr_text {
		width: 100%;
		text-align: center;
		color: #c4c4c4;
		font-size: 12px;
	}

	.delivery_count_l_b>input:focus .delivery_count_l_b {
		border-bottom: 1px solid #26CAD6;
	}

	/* // 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 99;
		background: rgba(0, 0, 0, 0.6);
	}

	.sq_ewm {
		position: absolute;
		top: 10%;
		left: 50%;
		margin-left: -300px;
		width: 620px;
		background-color: #fff;
		border-radius: 10px;
		overflow: hidden;
		z-index: 99;
	}

	.sq_ewm .sq_ewm_title {
		height: 60px;
		color: #424242;
		text-align: left;
		line-height: 60px;
		padding-left: 16px;
		font-size: 1.3rem;
		border-bottom: 1px solid #ddd;
	}

	.sq_ewm .gb_sqewm {
		position: absolute;
		top: 24px;
		right: 20px;
		cursor: pointer;
		width: 16px;
		height: 16px;
	}

	.xy_warp {
		width: 95%;
		margin: 20px auto;
	}

	.xy_floot {
		height: 60px;
		margin-top: 20px;
		border-top: 1px solid #dddddd;
	}

	.xy_floot>div {
		float: right;
		border: 1px solid;
		padding: 6px 14px;
		border-radius: 6px;
		margin-top: 12px;
		margin-right: 20px;
		cursor: pointer;

	}

	.calls {
		font-size: 12px;
		color: #2aa2a3;
		width: 80px;
	}
</style>
